import {stage} from './stage';

const platform = {
    prod: {
        portal: 'https://portal.flexi.network',
        console: 'https://console.flexi.network',
        domains: 'https://www.flexi.domains',
        email: 'https://www.flexi.email',
        books: 'https://www.flexiebooks.com',
        bot: 'https://www.flexi.bot',
        devops: 'https://devops.platform.flexi.network',
        platform: 'https://platform.flexi.network',
    },
    test: {
        portal: 'https://portal.test.flexi.network',
        console: 'https://console.test.flexi.network',
        domains: 'https://test.flexi.domains',
        email: 'https://www.flexi.email',
        books: 'https://www.flexiebooks.com',
        bot: 'https://www.flexi.bot',
        devops: 'https://devops.platform.test.flexi.network',
        platform: 'https://platform.test.flexi.network',
    },
    dev: {
        portal: 'https://portal.dev.flexi.network',
        console: 'https://console.dev.flexi.network',
        domains: 'https://dev.flexi.domains',
        email: 'https://www.flexi.email',
        books: 'https://www.flexiebooks.com',
        bot: 'https://www.flexi.bot',
        devops: 'https://devops.platform.dev.flexi.network',
        platform: 'https://platform.dev.flexi.network',
    },
    ide: {
        portal: 'https://localhost:8011',
        console: 'https://localhost:8012',
        domains: 'https://localhost:8021',
        email: 'https://www.flexi.email',
        books: 'https://www.flexiebooks.com',
        bot: 'https://www.flexi.bot',
        devops: 'https://localhost:8024',
        platform: 'https://localhost:8025',
    },
};

export default platform[stage];
